<template>
  <v-card :loading="loading" outlined>
    <v-card-text :class="arabic ? `arFont` : 'enFont'" class="pa-0 ma-0" v-if="item.featured_image && item.featured_image.url">
      <div 
        :style="`width:100%;height:226px;text-align:center;cursor:pointer;max-width:100%;background:url(${item.featured_image.url});background-size: cover;`"
      >
        <div style="position: absolute;left: 0;" class="pa-3">
          <v-btn color="primary" dark small @click.prevent="editItem(item)" v-if="master">{{i18n['update']}}</v-btn>
        </div>
        <div style="position: absolute;right: 0;" class="pa-3" v-if="item.tags.length">
          <v-chip x-small>
            {{item.tags[0][language]}}
          </v-chip>
        </div>
      </div>
    </v-card-text>
    <div style="position: absolute;left: 0;" :class="arabic ? `arFont pa-3` : 'enFont pa-3'" v-else>
      <v-btn color="primary" dark small @click.prevent="editItem(item)" v-if="master">{{i18n['update']}}</v-btn>
    </div>

    <v-card-text :class="arabic ? `arFont` : 'enFont'" v-if="item">
      <div class="font-weight-bold primary--text" :style="`font-size:${arabic?'18':'13'}px;height:44px;`">
        {{item['title_' + language]}}
      </div>
    </v-card-text>
    <v-card-text :class="arabic ? `arFont py-0` : 'enFont py-0'" v-if="item">
      <v-row class="pa-1" style="height:109.6px;">
        <v-col cols="2" v-for="(price, p) in item.prices" :key="'price-'+p" class="pa-0 text-center">
          <img :src="`/flags/${price.country.alpha2Code.toLowerCase()}.png`" height="22px" />
          <div :style="`font-size:${arabic?'13':'11'}px;`">${{price.formatted_price}}</div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions :class="arabic ? `arFont` : 'enFont'">
      <v-spacer></v-spacer>
      <v-btn color="primary" block dark @click.prevent="showItem(item)">
        <v-icon>
          category
        </v-icon>
        {{i18n['details']}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AppImg from '@/components/imgPlaceholder';

export default {
  components: {
    AppImg
	},
  props:['item', 'loading'],
  methods:{
    editItem(item) {
			this.$router.push(`/wholesale-product/${item.id}/edit`)
		},
    showItem(item) {
      const url = `https://ninjasellers.com/wholesale-product/${item.id}/details`
      window.open(url, '_blank').focus();
		},
    reloadData(){
      this.$emit('reloadData')
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    countries() {
      return this.$store.state.countries_[this.language]
    },
    master() {
      return this.$store.state.user.role == 'master';
    },
  },
}
</script>